import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { withTheme } from '../ThemeProvider';
import { IModalHeader } from './Header';
import { StyledTitle } from './styles';

export interface ITitleProps extends IModalHeader {
  theme?: any;
}

const TitleComponent: React.FC<ITitleProps> = ({ title, icon, className }) => {
  return (
    <StyledTitle className={className}>
      {icon ?? <FaPlus size={24} />}
      <p>{title ?? 'Title'}</p>
    </StyledTitle>
  );
};

export const Title = withTheme(TitleComponent);
